import React, { useState, useMemo, useEffect } from 'react'
import ReactDOM from 'react-dom'
import CssBaseline from '@material-ui/core/CssBaseline'
import { Provider } from 'react-redux'

import './config'

import ThemeProvider from './components/Theme'
import LiteralsProvider from './components/Literals'
import Router from './Router'

import LandingPageMarketing from './components/LandingMarketing'
import AgeGate from './components/AgeGate'
import CookieBanner from '~/components/Banner/Cookie'
import AppContainer from './containers/App'
import registerServiceWorker from './registerServiceWorker'
import configureStore from './store'
import { parseParams, getDomain } from './utils'
import track from './track'
import ls from './localStorage'
import Cookie from './cookie'

import './app.css'

const lastMinuteOfYear9999 = new Date(Date.UTC(9999, 11, 31, 23, 59))

function inIframe() {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

function initConfigs() {
  const params = parseParams()
  const store = configureStore({ config: params })

  if (params.sessionMode && params.sessionMode === 'anonimo') {
    Cookie.set('session-mode', params.sessionMode, getDomain(), lastMinuteOfYear9999.toUTCString())
  }

  registerServiceWorker(store)

  return [store, params]
}

const App = () => {
  const urlDomain = window.location.toString()
  const [store, params] = useMemo(initConfigs, [])
  const [showAgeGate, setShowAgeGate] = useState(params.ageGate && !inIframe())

  const userConsentStorage = ls.getItem('gofind-user-allow-cookies')

  useEffect(() => {
    track('APP_PAGEVIEW', { name: params.brandName })

    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href =
      'https://fonts.googleapis.com/css2?family=Alegreya:wght@400;500;700&family=PT+Sans:wght@400;700&family=Roboto:wght@300;400;500;700&display=swap&family=Roboto+Condensed:wght@300;400;700&family=STIX+Two+Text:wght@400;500;700&display=swap'

    document.head.appendChild(link)
  }, [params])

  if (
    (urlDomain.includes('www.pertinhodemim') || urlDomain.includes('www.aquiperto')) &&
    !urlDomain.includes('/loja')
  ) {
    return (
      <ThemeProvider config={params}>
        <LiteralsProvider language={params.language}>
          <LandingPageMarketing />
        </LiteralsProvider>
      </ThemeProvider>
    )
  }

  return (
    <>
      <Provider store={store}>
        <LiteralsProvider language={params.language}>
          <ThemeProvider config={params}>
            <CssBaseline />
            {showAgeGate ? (
              <AgeGate
                imageUrl={params.imageUrl}
                ageGateRedirect={params.ageGateRedirect}
                ageGateMessage={params.ageGateMessage}
                setShowAgeGate={setShowAgeGate}
              />
            ) : (
              <Router config={params}>
                <AppContainer />
              </Router>
            )}

            {!inIframe() && !userConsentStorage && <CookieBanner language={params.language} />}
          </ThemeProvider>
        </LiteralsProvider>
      </Provider>
    </>
  )
}

ReactDOM.render(<App />, document.getElementById('root'))
